import type React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import AppSidebar from "../Sidebar/AppSidebar";
import { SidebarProvider, SidebarInset } from "../../ui/sidebar";

const Layout: React.FC = () => {
	return (
		<SidebarProvider>
			<AppSidebar />
			<SidebarInset>
				<div className="flex flex-col h-screen">
					<Header />
					<main className="flex-1 overflow-y-auto p-4">
						<Outlet />
					</main>
				</div>
			</SidebarInset>
		</SidebarProvider>
	);
};

export default Layout;
